import { CONFIG } from '../config/config.js';

export class ChunkSizeCalculator {
  constructor() {
    this.speedSamples = [];
    this.currentChunkSize = CONFIG.FIXED_CHUNK_SIZE;
  }

  calculateOptimalSize(bytesUploaded, timeElapsedMs) {
    if (!CONFIG.USE_DYNAMIC_CHUNK_SIZE) {
      return CONFIG.FIXED_CHUNK_SIZE;
    }

    const speedBps = (bytesUploaded / timeElapsedMs) * 1000;
    
    this.speedSamples.push(speedBps);
    if (this.speedSamples.length > CONFIG.SPEED_SAMPLES) {
      this.speedSamples.shift();
    }

    const avgSpeed = this.speedSamples.reduce((a, b) => a + b, 0) / this.speedSamples.length;

    const targetTime = 3;
    let optimalSize = Math.round(avgSpeed * targetTime);

    optimalSize = Math.max(CONFIG.MIN_CHUNK_SIZE, optimalSize);
    optimalSize = Math.min(CONFIG.MAX_CHUNK_SIZE, optimalSize);

    this.currentChunkSize = optimalSize;
    return optimalSize;
  }

  getCurrentSize() {
    return this.currentChunkSize;
  }

  getCurrentSpeed() {
    if (this.speedSamples.length === 0) {
      return 0;
    }
    const avgSpeed = this.speedSamples.reduce((a, b) => a + b, 0) / this.speedSamples.length;
    return avgSpeed / (1024 * 1024);
  }

  reset() {
    this.speedSamples = [];
    this.currentChunkSize = CONFIG.FIXED_CHUNK_SIZE;
  }
}

/**
 * Calculate initial chunk size based on file size and configuration
 * @param {number} fileSize - Size of file in bytes
 * @returns {Promise<number>} - Chunk size in bytes
 */
export async function calculateChunkSize(fileSize) {
  if (!CONFIG.USE_DYNAMIC_CHUNK_SIZE) {
    return CONFIG.FIXED_CHUNK_SIZE;
  }
  
  // For initial calculation, use a reasonable chunk size based on file size
  // This will be adjusted during upload based on actual speeds
  let initialSize = CONFIG.FIXED_CHUNK_SIZE;
  
  // For very large files, start with larger chunks
  if (fileSize > 100 * 1024 * 1024) { // > 100MB
    initialSize = Math.min(CONFIG.MAX_CHUNK_SIZE, 10 * 1024 * 1024); // 10MB max
  } else if (fileSize > 50 * 1024 * 1024) { // > 50MB
    initialSize = Math.min(CONFIG.MAX_CHUNK_SIZE, 5 * 1024 * 1024); // 5MB max
  }
  
  return Math.max(CONFIG.MIN_CHUNK_SIZE, initialSize);
}
